import z from "zod";
import { BaseSchema } from "../common";
import { BathroomSchema, BedRoomSchema, LivingRoomSchema, UnitTypeEnum } from "./common";

export const PlanSchema = z.object({
  ...BaseSchema.shape,
  unitType: UnitTypeEnum.nullish(),
  bedroom: BedRoomSchema,
  livingRoom: LivingRoomSchema,
  bathroom: BathroomSchema,
  // A missing price represents an "on request" plan. Zero is not a valid price.
  price: z.number().positive().optional(),
  discountPercent: z.number().min(0).max(100).optional(),
  area: z.number().array(),
  projectId: z.uuidv7(),
  image: z.string().optional(),
  altText: z.string().nullish(),
});
